import { useEffect, useState } from "react";
import { IoIosSearch } from "react-icons/io";
import Spinner from "../../components/Spinner";
import shadow from "../../assets/pic/shadow.svg";
import { useParams } from "react-router-dom";
import Footer from "./Footer";
import { LayoutForLandingPage } from "./Home";
import GenerateCardPopup from "../../components/GenerateCardPopup";
const BrowseCards = () => {
  const [initialCards, setInitialCards] = useState([]);
  const [cards, setCards] = useState([]);
  const [occasion, setOccasion] = useState([]);
  const [selectedOccasion, setSelectedOccasion] = useState("");
  const [theme, setTheme] = useState("");
  const [forWhom, setForWhom] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [cardsLoader, setCardsLoader] = useState(false);
  const { cardType } = useParams();
  useEffect(() => {
    if (cardType === "birthday-card") {
      setSelectedOccasion("Birthday");
    } else if (cardType === "fathewewers-day") {
      setSelectedOccasion("Fathewewer's Day");
    } else if (cardType === "mothers-day") {
      setSelectedOccasion("Mother's Day");
    }
  }, [cardType]); // Add cardType as a dependency

  useEffect(() => {
    const filteredCards = initialCards.filter((card) => {
      const matchesTheme = theme
        ? card.categories.some((category) =>
            category.name.toLowerCase().includes(theme.toLowerCase())
          )
        : true;
      const matchesOccasion = selectedOccasion
        ? card.categories.some((category) => category.name === selectedOccasion)
        : true;
      const matchesForWhom = forWhom
        ? card.tags.some(
            (tag) => tag.name.toLowerCase() === forWhom.toLowerCase()
          )
        : true;
      return matchesOccasion && matchesForWhom && matchesTheme;
    });

    setCards(filteredCards);
  }, [selectedOccasion, forWhom, initialCards, theme]);

  useEffect(() => {
    setCardsLoader(true);
    const fetchCards = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/card/get-cards`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await res.json();
      setCardsLoader(false);
      setInitialCards(data.data);
      setCards(data.data);
    };
    fetchCards();
  }, []);

  useEffect(() => {
    const fetchOccasion = async () => {
      const token = localStorage?.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/event/get-active-event`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const res = await response.json();
      const status = res.code;
      if (status === 200) {
        setOccasion(res.data);
      }
    };
    fetchOccasion();
  }, []);

  return (
    <section className="flex">
      <div className="w-full">
        {cardsLoader ? (
          <div className="w-screen h-screen flex items-center justify-center ">
            <Spinner props="Loading..." size={"100"} />
          </div>
        ) : (
          <LayoutForLandingPage>
            {showModel && (
              <GenerateCardPopup
                toggleOrderModal={() => {
                  setShowModel(false);
                }}
                selectedCard={""}
                selectedCardID={""}
                cards={cards}
                type={"demo"}
              />
            )}
            <div className="py-4 mt-20">
              <div className="flex lg:flex-row flex-col lg:gap-0 gap-5 items-start justify-between m-2">
                <div className="flex flex-col lg:w-[35%] w-full">
                  <h1 className="text-4xl text-gray-500 lg:text-left text-center font-bold mb-5">
                    Browse Cards
                  </h1>
                  <div className="flex items-center gap-x-4 w-full">
                    <select
                      name="selectedOccasion"
                      value={selectedOccasion}
                      onChange={(e) => setSelectedOccasion(e.target.value)}
                      className="py-3 bg-white border-b-2 border-primary placeholder:text-gray-300 w-full"
                    >
                      <option value="">Choose Occasion</option>
                      {occasion.map((occasion) => (
                        <option key={occasion._id} value={occasion.name}>
                          {occasion.name}
                        </option>
                      ))}
                    </select>
                    <select
                      name="forWhom"
                      value={forWhom}
                      onChange={(e) => setForWhom(e.target.value)}
                      required
                      className="py-3 bg-white border-b-2 border-primary placeholder:text-gray-300 w-full"
                    >
                      <option value="">For Whom?</option>
                      <option value="Male">For Him</option>
                      <option value="female">For Her</option>
                    </select>
                  </div>
                </div>
                <div className="relative w-full lg:w-[40%]">
                  <input
                    type="text"
                    name="theme"
                    value={theme}
                    onChange={(e) => setTheme(e.target.value)}
                    placeholder="Search for Themes"
                    className="bg-slate-50 shadow-md border-2 border-primary rounded-lg px-4 py-3 w-full"
                  />
                  <IoIosSearch
                    size={25}
                    className="absolute inset-y-0 right-1 top-3 text-primary"
                  />
                </div>
              </div>
              <div className="xl:grid grid-cols-5 flex flex-wrap items-center justify-center gap-3 my-10">
                {cards.map((card, index) => (
                  <div className="relative w-fit" key={index}>
                    <div>
                      <div className="flex flex-col justify-center items-center">
                        <img
                          src={card.thumbnail}
                          alt="placeholder_img"
                          className="relative rounded-md w-72 inset-[-1] shadow-lg"
                        />
                        <img className="mt-3 w-[80%] mb-2" src={shadow} alt="" />
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        // setSelectedCard(card.thumbnail);
                        // setSelectedCardID(card._id);
                        setShowModel(true);
                      }}
                      className="border-2 border-primary text-primary text-lg py-1 mt-3 mb-4 w-full rounded-md hover:bg-primary-light"
                    >
                      Select
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </LayoutForLandingPage>
        )}
        <Footer />
      </div>
    </section>
  );
};

export default BrowseCards;
